// libs
import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react'
// store
import { persistor, store } from 'store/store'

const ReduxProvider = ({ children }) => {
  return (
    <Provider store={store} stabilityCheck='never'>
      <PersistGate loading={null} persistor={persistor}>
        {children}
      </PersistGate>
    </Provider>
  )
}

export default ReduxProvider
